import { createIcon } from '@chakra-ui/icons';

export const MenuIcon = createIcon({
  displayName: 'MenuIcon',
  viewBox: '0 0 200 200',
  path: (
    <>
      <circle cx='100' cy='25' r='25' fill='currentColor'/>
      <circle cx='100' cy='100' r='25' fill='currentColor'/>
      <circle cx='100' cy='175' r='25' fill='currentColor'/>
    </>
  )
});
